import React from 'react';
import useAuth from "./useAuth";
import {PageError, PageLoading} from "apm/components/common";

export default function RequireAuth({children}: any) {
    const {user, error} = useAuth();
    
    if (error) {
        return <PageError/>;
    }
    if (!user) {
        return <PageLoading/>
    }
    return children;

}